export default __webpack_public_path__ + "static/media/Charlotte 9781408342381.f7d415c4.jpg";